function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './RectangularCards.css';
import React from 'react';
import { EGeneralCardsIconTypes } from '../GeneralCardIconCards';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { get } from '../../../utils';
import ScrollAnimation from 'react-animate-on-scroll';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import { isNotNil } from '../../../utils/IsNil';
import { tealiumMergeClickNewData, tealiumClickFunc } from '../../../utils/tealium';
import { convertToAnalyticObject } from '../../../utils/analytics';
const Cards = _ref => {
  let {
    item,
    params,
    eventsAnalytics
  } = _ref;
  const cardIconSrc = get(item, 'cardIcon.jss.value.src');
  const svgIcon = get(item, 'cardIconCode.jss.value');
  const cardIconAlt = get(item, 'cardIcon.jss.value.alt');
  const hasTitle = Boolean(get(item, 'title.jss.value'));
  const cardTitle = get(item, 'title.jss.value');
  const hasDescription = Boolean(get(item, 'description.jss.value'));
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  return /*#__PURE__*/React.createElement(React.Fragment, null, (hasTitle || hasDescription) && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon",
    "data-cy": "general-card-icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: `card-box theme-contrast`
  }, /*#__PURE__*/React.createElement("div", {
    className: "iconCircle"
  }, isNotNil(svgIcon) && svgIcon.includes("svg") ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: svgIcon
    },
    className: "h__icon"
  }) : /*#__PURE__*/React.createElement("img", {
    className: "h__icon",
    src: BASE_URL + cardIconSrc,
    alt: cardIconAlt
  })), /*#__PURE__*/React.createElement("div", {
    className: "titleDescription"
  }, hasTitle ? item.ctaLink.jss.value.href ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "cardTitleLink",
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), cardTitle),
    href: item.ctaLink.jss.value.href
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  })) : /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null, hasDescription ? item.ctaLink.jss.value.href ? /*#__PURE__*/React.createElement(RouterLink, {
    className: "cardDescriptionLink",
    href: item.ctaLink.jss.value.href
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  })) : /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null))));
};
const RectangularCards = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const defaultCardsHasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const childrenItems = get(fields, 'data.item.children', []);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const items = childrenItems.length ? childrenItems.filter(item => item.title && item.description) : [];
  const classItemsContainerMap = {
    2: "twoItemsContainer",
    3: "threeItemsContainer",
    4: "fourItemsContainer"
  };
  const classItemWidthMap = {
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };
  const cardsProps = {
    params: {
      eventCat: params.eventCat,
      eventName: params.eventName,
      eventAct: params.eventAct,
      ColorHex: params.ColorHex,
      BackgroundColorHex: params.BackgroundColorHex
    }
  };
  if (items.length >= 5) {
    console.warn(`provided ${items.length} items, but max count is 4 in ${EGeneralCardsIconTypes.Rectangular} type`);
  }
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderItems04 = () => {
    if (items.length <= 1) {
      console.warn(`provided ${items.length} cards but requires 2 or more`);
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: items.length < 5 ? classItemsContainerMap[items.length] : classItemsContainerMap[4]
    }, items.slice(0, 4).map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: `itemWidth ${items.length < 5 ? classItemWidthMap[items.length] : classItemWidthMap[4]}`,
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: item.id
    }, /*#__PURE__*/React.createElement(Cards, _extends({}, cardsProps, {
      item: item,
      eventsAnalytics: eventsAnalytics
    })))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "M07_rectangular",
    isDetSite: isDetSite
  }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, defaultCardsHasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__desc",
    field: fields.data.item.description.jss
  }) : null, renderItems04());
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className,
    style,
    isDetSite
  } = _ref3;
  const commonStyles = isDetSite ? "ccn61pw" : "cvjdw7u";
  const ltrStyles = isDetSite ? "l16fec8a" : "li8sac5";
  const rtlStyles = isDetSite ? "rwcrvsw" : "rfrbx73";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export { RectangularCards };